import BBBTrust from "../components/BBBTrust";

export default function Trust() {
    return (
        <main className="mx-auto max-w-5xl px-6 py-14">
            <header className="text-center">
                <h1 className="text-3xl font-semibold text-gray-900">Trust & Compliance</h1>
                <p className="mt-3 text-gray-600">
                    We prioritize transparency, ethical business practices, and client satisfaction.
                </p>
            </header>

            <div className="mt-10 flex justify-center">
                <BBBTrust size="large" />
            </div>

            <section className="mt-12 space-y-6 text-gray-700 leading-relaxed">
                <div className="rounded-xl border border-gray-200 bg-white p-6">
                    <h2 className="text-lg font-semibold text-gray-900">BBB Accreditation</h2>
                    <p className="mt-2">
                        Secure ID Technologies of Florida LLC is a BBB Accredited Business with an A- rating.
                        Accreditation reflects our commitment to honesty, responsiveness, and integrity.
                    </p>
                </div>

                <div className="rounded-xl border border-gray-200 bg-white p-6">
                    <h2 className="text-lg font-semibold text-gray-900">How we work</h2>
                    <ul className="mt-2 list-disc pl-5 space-y-2">
                        <li>Clear scope, deliverables, and timelines.</li>
                        <li>Written quotes and documented changes.</li>
                        <li>Fast communication and issue resolution.</li>
                        <li>Client privacy and careful handling of sensitive data.</li>
                    </ul>
                </div>

                <div className="rounded-xl border border-gray-200 bg-white p-6">
                    <h2 className="text-lg font-semibold text-gray-900">Contact</h2>
                    <p className="mt-2">
                        Questions about our services or a concern to resolve? Email{" "}
                        <a className="text-indigo-600 hover:underline" href="mailto:info@secureidtechnologies.com">
                            info@secureidtechnologies.com
                        </a>
                        .
                    </p>
                </div>
            </section>
        </main>
    );
}
